module.exports = __webpack_public_path__ + "img/loginbg.58226f8c.png";